/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
const DoorState = {
  OPEN: 'OPEN',
  OPENING: 'OPENING',
  CLOSED: 'CLOSED',
  CLOSING: 'CLOSING',
  UNKNOWN: 'UNKNOWN'
};

export { DoorState as D };

//# sourceMappingURL=sliding-door-interface-7c209a7c.js.map